export const AddressFormActionType = {
   SET_INITIAL_ADDRESS: "SET_INITIAL_ADDRESS",
   SET_ATTENTION_NAME: "SET_ATTENTION_NAME",
   SET_HOUSE: "SET_HOUSE",
   SET_STREET: "SET_STREET",
   SET_CITY: "SET_CITY",
   SET_PINCODE: "SET_PINCODE",
   SET_STATE: "SET_STATE",
   SET_COUNTRY: "SET_COUNTRY",
   SET_PHONENUMBER: "SET_PHONENUMBER",
   SET_ERROR_MESSAGE: "SET_ERROR_MESSAGE",
   SET_LOADING: "SET_LOADING",
   RESET_FORM: "RESET_FROM",
};

Object.freeze(AddressFormActionType);
